import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询列表
export const querySMSList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSMSList', { ...state.list, loading: true });
    const res: IPageData = await $http.post('message/email/page', payload);
    commit('setSMSList', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setSMSList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查看详情
export const querySMSDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSMSDetail', { data: null, loading: true });
    const res = await $http.post('', payload);
    commit('setSMSDetail', { data: res });
  } catch (e) {
    commit('setSMSDetail', { data: null });
  }
};

// 添加
export const addSMS: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('message/sms/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功, 2秒后跳转回列表页面' });
    setTimeout(() => router.push({ name: 'message-sms' }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑
export const editSMS: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('message/sms/edit', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '编辑成功, 2秒后跳转回列表页面' });
    setTimeout(() => router.push({ name: 'message-sms' }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 删除
export const deleteSMS: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('message/sms/delete', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};
